import { useState } from 'react'
import { Button } from '../primitives/Button'
import s from './CopyLine.module.css'

/**
 * A sentence to say to your agent (or a command to paste), on Glass, with a Copy button. Word for word: what's here
 * is what gets copied.
 */
export function CopyLine(props: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false)
  const copy = () => {
    void navigator.clipboard?.writeText(props.text).then(
      () => {
        setCopied(true)
        setTimeout(() => setCopied(false), 1600)
      },
      () => {},
    )
  }
  return (
    <figure className={s.line}>
      {props.label && <figcaption className={s.label}>{props.label}</figcaption>}
      <blockquote className={s.text}>{props.text}</blockquote>
      <span className={s.copy}>
        <Button size="sm" icon={copied ? 'check' : 'copy'} onClick={copy}>
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </span>
    </figure>
  )
}
